import { NextPage } from 'next'
import Image from 'next/image'
import Link from 'next/link'
import { Button, Container } from 'react-bootstrap'
import { FaArrowRight, FaFileAlt } from 'react-icons/fa'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import styles from '~/styles/_recruit.module.scss'

export const getStaticProps = makeLocaleStaticProps

const RecruitPage: NextPage = () => {
  return (
    <DefaultLayout
      head={{
        title: 'OptHub 採用情報 | Mathlog',
        description:
          'OptHubは数学情報発信メディア「Mathlog」を運営する会社です。最適化をはじめとするAI技術で、多様な業種の社会課題に取り組んでいます。',
        index: true,
      }}
      padding={{ sp: false, pc: false }}
    >
      <div className={styles.recruitPage}>
        {/* ヘッダーセクション */}
        <section className={styles.heroSection}>
          <Container className={styles.heroContent}>
            <div className={styles.logoContainer}>
              <div className={styles.logoWrapper}>
                <Image
                  src="/logo_black.svg"
                  alt="Mathlog"
                  width={180}
                  height={40}
                  className={styles.mathlogLogo}
                />
                <div className={styles.servedBy}>served by</div>
                <Image
                  src="/opthub_logo_black.svg"
                  alt="OptHub"
                  width={180}
                  height={40}
                  className={styles.opthubLogo}
                />
              </div>
            </div>
          </Container>
        </section>

        {/* メインコンテンツ */}
        <section className={styles.mainSection}>
          <Container>
            <div className={styles.contentWrapper}>
              <h1 className={styles.mainHeading}>数学の力で、社会に最適解を</h1>

              <div className={styles.textContent}>
                <p className={styles.paragraph}>
                  OptHubは、数学情報発信メディア「Mathlog」を運営する会社です。
                </p>
                <p className={styles.paragraph}>
                  Mathlogでは、「数学の魅力の共有と発見」を通じて、数学・数理分野の発展に貢献すべく取り組んできました。
                </p>
                <p className={styles.paragraph}>
                  OptHubでは、こうした数学・アルゴリズムの知見を基盤として、産業界、ひいては社会の革新に向けた取り組みを日々進めています。
                </p>
                <p className={styles.paragraph}>
                  私たちOptHubは、「あらゆる現場に最適解を」というミッションのもと、
                  最適化をはじめとするAI技術で、多様な業種の社会課題に取り組んでいます。製造・運送・エネルギー・エンタメ・印刷・人材・倉庫など、
                  幅広い分野で価値を創出しています。さらに、OptHubは東京科学大学発ベンチャーに認定された企業であり、
                  長年にわたる研究成果を背景に、常に最先端の技術を現場へ届け続けます。
                </p>
              </div>

              {/* CTAボタン */}
              <div className={styles.ctaButtonsWrapper}>
                <div className={styles.ctaButtons}>
                  <Link href="https://corp.opthub.ai/recruit">
                    <a target="_blank" rel="noopener noreferrer">
                      <Button
                        variant="outline-primary"
                        size="lg"
                        className={styles.outlineButton}
                      >
                        <FaFileAlt className={styles.buttonIcon} />
                        応募要項を確認する
                      </Button>
                    </a>
                  </Link>
                  <Link href="https://corp.opthub.ai/entry">
                    <a target="_blank" rel="noopener noreferrer">
                      <Button
                        variant="primary"
                        size="lg"
                        className={styles.primaryButton}
                      >
                        応募ページへ進む
                        <FaArrowRight className={styles.buttonIcon} />
                      </Button>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </Container>
        </section>

        {/* フッターセクション */}
        <section className={styles.footerSection}>
          <Container>
            <div className={styles.footerContent}>
              <p className={styles.footerText}>
                一緒に、数学の力で社会を変えていきませんか？
              </p>
            </div>
          </Container>
        </section>
      </div>
    </DefaultLayout>
  )
}

export default RecruitPage
